import React, { useState } from "react";
import { Grid } from "@mui/material";
import Box from "@mui/material/Box";
import { FormControl, TextField } from "@mui/material";
import RemoveIcon from "../../../images/remove.png";
import PlusIcon from "../../../images/plus_icon.png";
import { DemoContainer } from "@mui/x-date-pickers/internals/demo";
import { AdapterDayjs } from "@mui/x-date-pickers/AdapterDayjs";
import { LocalizationProvider } from "@mui/x-date-pickers/LocalizationProvider";
import { DatePicker } from "@mui/x-date-pickers/DatePicker";
import dayjs from "dayjs";
import ApiClient from "../../common/ApiClient";
import { useEffect } from "react";
import DeleteDialog from "../../ip/DeleteDialog";
import { useParams } from "react-router-dom";

import styles from "../../ott/OttPlatform/Stream.module.css";
import {
  Table,
  TableBody,
  TableCell,
  TableContainer,
  TableHead,
  TableRow,
  Paper,
} from "@mui/material";
import Button from "@mui/material/Button";
import DeleteIcon from "@mui/icons-material/Delete";
import InputLabel from "@mui/material/InputLabel";
import Select from "@mui/material/Select";
import MenuItem from "@mui/material/MenuItem";
import Loader from "../../common/Loader/Loader";
import Snackbar from "@mui/material/Snackbar";
import Alert from "@mui/material/Alert";
import AddBoxIcon from "@mui/icons-material/AddBox";
import IndeterminateCheckBoxIcon from "@mui/icons-material/IndeterminateCheckBox";
import { convertDate, convertDateToIndianFormat } from "../../Helper";

const ThreatricalScreening = ({
  setFormDataMain,
  setOttPlatformErrors,
  errors,
  formDataMain,
}) => {
  const [maximumLimitReach, setMaximumLimitReach] = useState(true);
  const [loading, setLoading] = useState(false);
  const [alertOpen, setAlertOpen] = useState(false);
  const [alertMessage, setAlertMessage] = useState("");
  const [alertSeverity, setAlertSeverity] = useState("success");

  const [showForm, setShowForm] = useState(true);
  const { id = null } = useParams();
  const { putRequest, getRequest, deleteRequest } = ApiClient();
  const [errorsForm, setErrorsForm] = useState({});
  const [preData, setPreData] = useState([]);
  const [formData, setformData] = React.useState({
    ott_form_id: id,
    festival_name: "",
    date_of_festival: null,
    date_of_festival_format: null,
    address: "",
  });
  const loadData = async () => {
    const preData = await getRequest(`ott/${id}/threatrical-screening`);
    const data = preData.data;
    if (data.length > 0) {
      setShowForm(false);
      setFormDataMain((prevData) => ({
        ...prevData,
        is_threatical_screening_added: 1,
      }));
      setOttPlatformErrors({
        ...errors,
        is_threatical_screening_added: null,
      });
      if (data.length >= 5) {
        setMaximumLimitReach(false);
      } else {
        setMaximumLimitReach(true);
      }
    } else {
      setShowForm(true);
      setFormDataMain((prevData) => ({
        ...prevData,
        is_threatical_screening_added: null,
      }));
    }
    //  if (data && data.length < 5) setShowAddNewEntry(true)
    setPreData(data);
  };
  useEffect(() => {
    loadData();
  }, []);

  const validateForm = () => {
    const newErrors = {};
    if (!formData.festival_name)
      newErrors.festival_name = "Enter festival name";
    if (!formData.date_of_festival)
      newErrors.date_of_festival = "Select date of festival";
    if (!formData.address) newErrors.address = "Enter address of the festival";
    setErrorsForm(newErrors);
    return Object.keys(newErrors).length === 0;
  };
  const handleFormData = (e) => {
    const { name, value } = e.target;
    setformData((prevData) => ({
      ...prevData,
      [name]: value,
    }));
    errorsForm[name] = "";
    setErrorsForm(errorsForm);
  };
  const handleReleaseDate = (e) => {
    if (e) {
      const formattedDate = e.format("YYYY-MM-DD");
      setformData((prevData) => ({
        ...prevData,
        date_of_festival_format: dayjs(formattedDate),
        date_of_festival: formattedDate,
      }));
    }
    // Clear the error message for release_date
    setErrorsForm((prevErrors) => ({
      ...prevErrors,
      date_of_festival: "",
    }));
  };
  const Addmore = async (e) => {
    setShowForm(true);
  };
  const mini = async (e) => {
    setShowForm(false);
  };

  const submitForm = async (e) => {
    e.preventDefault();

    if (!validateForm()) return;
    setLoading(true);

    try {
      const addnnewdata = { ...formData };
      addnnewdata.date_of_festival = convertDate(formData.date_of_festival);
      const response = await putRequest(
        `ott/${id}/threatrical-screening`,
        addnnewdata,
      );

      if (!response.status) {
        throw new Error(`Error: ${response.status} ${response.statusText}`);
      }

      // console.log("Response producer:", response);

      // Reset form after co-Producer submission
      setformData({
        festival_name: "",
        date_of_festival: null,
        date_of_festival_format: null,
        address: "",
        ott_form_id: id,
      });
      loadData();
      // alert('Form has submitted successfully!');
      setAlertMessage("Data has been submitted successfully!");
      setAlertSeverity("success");
      setAlertOpen(true);
      //  await loadpreData();
    } catch (error) {
      console.error("Error: ", error);
      // alert('Error submitting form. Please try again later.');
      setAlertMessage("Error submitting form. Please try again later.");
      setAlertSeverity("error");
      setAlertOpen(true);
    } finally {
      setLoading(false); // Set loading to false when the API call finishes
    }
  };

  const [openDeleteConfirm, setOpenDeleteConfirm] = useState(false);
  const [prepareDelete, setPrepareDelete] = useState(null);

  const handleDeleteOpen = (e) => {
    e.preventDefault();
    const { name, value } = e.target;
    setPrepareDelete(value);
    setOpenDeleteConfirm(true);
  };

  const handleDeleteClose = (e) => {
    e.preventDefault();
    setOpenDeleteConfirm(false);
  };
  const submitDelete = async (e) => {
    e.preventDefault();
    setLoading(true);

    try {
      const response = await deleteRequest(
        `ott/${id}/threatrical-screening/${prepareDelete}`,
        formData,
      );

      if (!response.status) {
        throw new Error(`Error: ${response.status} ${response.statusText}`);
      }
      loadData();
      // alert('Record deleted successfully!');
      setAlertMessage("Data has been deleted successfully!");
      setAlertSeverity("error");
      setAlertOpen(true);
      //  await loadpreData();
    } catch (error) {
      console.error("Error: ", error);
      // alert('Error submitting form. Please try again later.');
      setAlertMessage("Error submitting form. Please try again later.");
      setAlertSeverity("error");
      setAlertOpen(true);
    } finally {
      setLoading(false); // Set loading to false when the API call finishes
    }
    setOpenDeleteConfirm(false);
  };

  return (
    <>
      {loading && <Loader />}
      <TableContainer component={Paper} style={{ marginTop: "10px" }}>
        <Table sx={{ minWidth: 650 }} aria-label="caption table">
          {preData && preData.length > 0 ? (
            <TableHead>
              <TableRow>
                <TableCell align="center">
                  (i) Name of the Festival/Screening
                </TableCell>
                <TableCell align="center">
                  (ii) Date of the Festival/Screening
                </TableCell>
                <TableCell align="center">
                  (iii) Address of the Festival/Screening
                </TableCell>
                <TableCell align="center">
                  {/* {showForm ? (
                                        <Button onClick={mini}><IndeterminateCheckBoxIcon /></Button>
                                    ) : (
                                        <Button onClick={Addmore}><AddBoxIcon /></Button>
                                    )} */}
                  {maximumLimitReach ? (
                    showForm ? (
                      <Button onClick={mini}>
                        <IndeterminateCheckBoxIcon />
                      </Button>
                    ) : (
                      <Button onClick={Addmore}>
                        <AddBoxIcon />
                      </Button>
                    )
                  ) : (
                    <></>
                  )}
                </TableCell>
              </TableRow>
            </TableHead>
          ) : (
            <></>
          )}
          <TableBody>
            {preData.map((row) => (
              <TableRow
                key={row.name}
                sx={{ "&:last-child td, &:last-child th": { border: 0 } }}
              >
                <TableCell align="center">{row.festival_name}</TableCell>
                <TableCell align="center">
                  {convertDateToIndianFormat(row.date_of_festival)}
                </TableCell>
                <TableCell align="center">{row.address}</TableCell>
                <TableCell align="center">
                  <Button
                    value={row.id}
                    onClick={handleDeleteOpen}
                    variant="outlined"
                    color="error"
                    startIcon={<DeleteIcon style={{ color: "#d32f2f" }} />}
                  >
                    Delete
                  </Button>
                  <DeleteDialog
                    open={openDeleteConfirm}
                    handleClose={handleDeleteClose}
                    handleDelete={submitDelete}
                  />
                </TableCell>
              </TableRow>
            ))}
            {showForm ? (
              <TableRow>
                <TableCell align="center" colSpan={4}>
                  <Grid container spacing={2}>
                    <Grid item xs={3} sm={3} md={3} lg={3}>
                      <Box>
                        <TextField
                          name="festival_name"
                          label="(i) Name of the Festival/Screening"
                          type="text"
                          fullWidth
                          variant="outlined"
                          value={formData.festival_name}
                          onChange={handleFormData}
                        />
                      </Box>
                      {errorsForm.festival_name && (
                        <p className="text-danger">
                          {errorsForm.festival_name}
                        </p>
                      )}
                    </Grid>
                    <Grid item xs={3} sm={3} md={3} lg={3}>
                      <Box style={{ width: "100%" }}>
                        <FormControl>
                          <LocalizationProvider dateAdapter={AdapterDayjs}>
                            <DemoContainer components={["DatePicker"]}>
                              <DatePicker
                                label="(ii) Date of the Festival/Screening"
                                name="date_of_festival"
                                value={formData.date_of_festival_format}
                                onChange={handleReleaseDate}
                                minDate={dayjs("2025-08-01")}
                                maxDate={dayjs("2026-07-31")}
                                format="DD/MM/YYYY"
                                placeholderText="DD/MM/YYYY"
                                slotProps={{
                                  textField: {
                                    InputProps: { readOnly: true },
                                    readOnly: true,
                                  },
                                }}
                              />
                            </DemoContainer>
                          </LocalizationProvider>
                        </FormControl>
                        {errorsForm.date_of_festival && (
                          <p className="text-danger">
                            {errorsForm.date_of_festival}
                          </p>
                        )}
                      </Box>
                    </Grid>
                    <Grid item xs={3} sm={3} md={3} lg={4}>
                      <Box>
                        <TextField
                          name="address"
                          label="(iii) Address of the Festival/Screening"
                          type="text"
                          fullWidth
                          value={formData.address}
                          onChange={handleFormData}
                        />
                      </Box>
                      {errorsForm.address && (
                        <p className="text-danger">{errorsForm.address}</p>
                      )}
                    </Grid>
                    <Grid item xs={3} sm={3} md={3} lg={2}>
                      <Box>
                        <Button
                          variant="contained"
                          color="success"
                          onClick={submitForm}
                        >
                          Save
                        </Button>
                        {errors.is_threatical_screening_added && (
                          <p className="text-danger error-handling">
                            {errors.is_threatical_screening_added}
                          </p>
                        )}
                      </Box>
                    </Grid>
                  </Grid>
                </TableCell>
              </TableRow>
            ) : (
              <></>
            )}
          </TableBody>
          {/* </TableFooter> */}
        </Table>
      </TableContainer>

      <Snackbar
        open={alertOpen}
        autoHideDuration={6000}
        onClose={() => setAlertOpen(false)}
        anchorOrigin={{ vertical: "top", horizontal: "right" }}
      >
        <Alert
          onClose={() => setAlertOpen(false)}
          severity={alertSeverity}
          variant="filled"
        >
          {alertMessage}
        </Alert>
      </Snackbar>
    </>
  );
};

export default ThreatricalScreening;
